import { useSellScores, usePerson } from "../../../reducers/personalDetailReducer/personDetailReducer";
import RemineCard from "./RemineCard";

const lookupAddressType = (person, addressId) => {
  const address = (person?.included || []).find(
    (item) => item.type === "address" && String(item.id) === String(addressId),
  );
  return address?.attributes?.address_type || "home";
};

const RemineCardContainer = () => {
  const sellScores = useSellScores();
  const person = usePerson();

  const scored = Object.entries(sellScores || {}).filter(([, level]) => Boolean(level));

  if (scored.length === 0) return null;
  // Multi: pass the number of scored addresses so the dial renders "N Scores".
  if (scored.length >= 2) return <RemineCard level={scored.length} />;

  const [addressId, level] = scored[0];
  return <RemineCard level={level} addressType={lookupAddressType(person, addressId)} />;
};

export default RemineCardContainer;
